var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3682_41143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.345 24 0 18.655 0 12C0 5.345 5.345 0 12 0C18.655 0 24 5.345 24 12C24 18.655 18.655 24 12 24ZM12 2.182C10.7092 2.17658 9.43003 2.42682 8.23641 2.9183C7.04278 3.40978 5.9583 4.13276 5.04553 5.04553C4.13276 5.9583 3.40978 7.04278 2.9183 8.23641C2.42682 9.43003 2.17658 10.7092 2.182 12C2.17658 13.2908 2.42682 14.57 2.9183 15.7636C3.40978 16.9572 4.13276 18.0417 5.04553 18.9545C5.9583 19.8672 7.04278 20.5902 8.23641 21.0817C9.43003 21.5732 10.7092 21.8234 12 21.818C13.2908 21.8234 14.57 21.5732 15.7636 21.0817C16.9572 20.5902 18.0417 19.8672 18.9545 18.9545C19.8672 18.0417 20.5902 16.9572 21.0817 15.7636C21.5732 14.57 21.8234 13.2908 21.818 12C21.8234 10.7092 21.5732 9.43003 21.0817 8.23641C20.5902 7.04278 19.8672 5.9583 18.9545 5.04553C18.0417 4.13276 16.9572 3.40978 15.7636 2.9183C14.57 2.42682 13.2908 2.17658 12 2.182Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4522 16.3633L10.9062 8.18128V4.36328H13.0882V8.18128L12.5422 16.3633H11.4522ZM10.9062 19.6353V17.4543H13.0882V19.6353H10.9062Z",
    fill: "#636363"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3682_41143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.2ac2a7009d88490ea2e05ebe256ba936.svg";
export { ForwardRef as ReactComponent };